// "use client";
import { LeftOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
import React from "react";
import { collapseItems } from "./QuestionsCollapseContents";

const QuestionsCollapse = () => {
  return (
    <Collapse
      items={collapseItems}
      bordered={false}
      accordion
      className="custom-collapse"
      expandIconPosition="end"
      expandIcon={({ isActive }) => (
        <LeftOutlined color={`  `} rotate={isActive ? 90 : 0} />
      )}
    />
  );
};

export default QuestionsCollapse;
